export default "__VITE_ASSET__83fdcfa1__"